export const SIZE_136_136 = 'Size136x136Crop';
export const SIZE_250_250 = 'Size250x250';
export const PAGES_UI_FEATURE_IMAGE = 'PagesUIFeatureImage';
export const LOGO = 'Size120x120';
export const CAMPAIGNS_V1_FEATURE_IMAGE = 'campaignherolarge';
export const CAMPAIGNS_V1_GALLERY_IMAGE = 'campaigngalleryxsmallretina';
